import React, { useState } from 'react';
import PageHero from './PageHero';
import { ArrowUpRight, Calendar, Clock, MapPin, Play, Bell, Newspaper } from 'lucide-react';
import studentsImg from '../assets/Banner-GMIS Students.png';

/* ── Inline SVG social icons (not in this lucide-react build) ── */
const IgIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </svg>
);
const FbIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
);
const YtIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.95C18.88 4 12 4 12 4s-6.88 0-8.59.47A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.95C5.12 20 12 20 12 20s6.88 0 8.59-.47a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
    <polygon fill="white" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
  </svg>
);
const LiIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);

/* ─── DATA ──────────────────────────────────────────────────── */

const GMIS_NEWS = [
  {
    id: 1,
    category: 'Media Feature',
    headline: 'GMIS Jakarta Recognised for Excellence in International Education',
    excerpt:
      'A leading Indonesian education publication spotlights GMIS Jakarta for its dual IB–Cambridge curriculum, holistic student development, and its growing reputation among Jakarta\'s international community.',
    author: 'Editorial Team',
    date: 'Oct 20, 2026',
    readTime: '4 min read',
    image: 'https://placehold.co/900x560/0e243e/ffffff?text=GMIS+News',
    featured: true,
  },
  {
    id: 2,
    category: 'Community',
    headline: 'Students Lead Sustainability Drive Across Campus',
    excerpt:
      'Inspired by their IB learning journey, GMIS students launched a campus-wide recycling initiative, partnering with local NGOs to reduce the school\'s environmental footprint.',
    author: 'GMIS Communications',
    date: 'Oct 14, 2026',
    readTime: '3 min read',
    image: 'https://placehold.co/600x400/c8a84b/0e243e?text=Sustainability',
    featured: false,
  },
  {
    id: 3,
    category: 'Achievement',
    headline: 'GMIS Science Olympiad Champions Head to National Finals',
    excerpt:
      'Five GMIS Primary students clinched first place at the regional round of the 2026 Science Olympiad, earning a berth in the national finals in Surabaya.',
    author: 'GMIS Academic Dept.',
    date: 'Oct 8, 2026',
    readTime: '2 min read',
    image: 'https://placehold.co/600x400/0e243e/c8a84b?text=Olympiad',
    featured: false,
  },
];

const UPDATES = [
  {
    id: 1,
    title: 'BSEISI Result',
    desc: 'The BSEISI Board results for the academic session are now published. Students and parents can access official scorecards and performance analysis online. Congratulations to all high achievers!',
    linkText: 'View Results',
    linkUrl: 'https://onlineassesments.gmis.sch.id/certificate/index.php',
    image: 'https://placehold.co/600x400/0e243e/ffffff?text=BSEISI+Results',
    tag: 'Academics',
    date: 'Oct 2, 2026',
  },
  {
    id: 2,
    title: 'Science Olympiad 2026',
    desc: 'Inspire, Think, Solve. Join the GMISSO 2026 Science Olympiad designed for young learners (Grades 1–5). A platform to explore creativity, critical thinking, and scientific curiosity.',
    details: [
      { icon: <Calendar size={13} />, text: 'Saturday, 16th May 2026' },
      { icon: <Clock size={13} />,    text: '9:30 AM' },
      { icon: <MapPin size={13} />,   text: 'Registration Closes: 1st May' },
    ],
    linkText: 'Register Now',
    linkUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeIIroANRKm80NEGv5I8er1OnGaw53bV8y2Ql1qhuLyYsewjQ/viewform',
    image: 'https://placehold.co/600x400/c8a84b/0e243e?text=Olympiad+2026',
    tag: 'Event',
    date: 'Sep 28, 2026',
  },
  {
    id: 3,
    title: 'Mid Term Report 2025–2026',
    desc: 'Access and download your child\'s Mid Term Report for 2025–2026. View detailed performance insights and academic progress online.',
    linkText: 'View Report',
    linkUrl: 'https://onlineassesments.gmis.sch.id/certificate/index.php',
    image: 'https://placehold.co/600x400/0e243e/ffffff?text=Mid+Term+Report',
    tag: 'Notice',
    date: 'Sep 20, 2026',
  },
];

const UPDATE_TAGS = ['All', 'Academics', 'Event', 'Notice', 'Sports', 'Community'];

const VIDEOS = [
  {
    id: 1,
    title: 'Welcome to GMIS Jakarta',
    desc: 'An introduction to our campus, community, and values.',
    thumb: 'https://placehold.co/800x450/0e243e/ffffff?text=Welcome+to+GMIS',
    youtubeId: '',
  },
  {
    id: 2,
    title: 'Science Olympiad Highlights 2026',
    desc: 'Relive the excitement of GMISSO 2026.',
    thumb: 'https://placehold.co/800x450/c8a84b/0e243e?text=Olympiad+2026',
    youtubeId: '',
  },
  {
    id: 3,
    title: 'Student Life at GMIS',
    desc: 'See how our students thrive beyond the classroom.',
    thumb: 'https://placehold.co/800x450/1a3a5c/c8a84b?text=Student+Life',
    youtubeId: '',
  },
];

const SOCIAL = [
  { id: 1, platform: 'Instagram', handle: '@gmisjkt',             url: 'https://instagram.com', icon: <IgIcon /> },
  { id: 2, platform: 'Facebook',  handle: 'GMIS Jakarta',         url: 'https://facebook.com',  icon: <FbIcon /> },
  { id: 3, platform: 'YouTube',   handle: 'GMIS Jakarta Official', url: 'https://youtube.com',   icon: <YtIcon /> },
  { id: 4, platform: 'LinkedIn',  handle: 'GMIS Jakarta',         url: 'https://linkedin.com',  icon: <LiIcon /> },
];

/* ═══════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════ */
export default function LatestNewsPage({ setPage, t }) {
  const [updateFilter, setUpdateFilter] = useState('All');
  const [videoModal,   setVideoModal]   = useState(null);

  const navCategory = t?.nav?.[4]?.label || 'News & Events';
  const homeLabel   = t?.nav?.[0]?.label || 'Home';

  const filteredUpdates =
    updateFilter === 'All' ? UPDATES : UPDATES.filter(u => u.tag === updateFilter);

  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen text-ink">

      {/* ── Hero ──────────────────────────────────────────────── */}
      <PageHero
        title={'News & Updates'}
        breadcrumbs={[homeLabel, navCategory, 'Latest News']}
        eyebrow={navCategory}
        subtitle={'Stay informed with the latest happenings, announcements, and achievements at GMIS Jakarta.'}
        bgImage={studentsImg}
      />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-[80px] py-16 lg:py-24 box-border">

        {/* ══════════════════════════════════════════════════════
            SECTION 1 — GMIS NEWS
        ══════════════════════════════════════════════════════ */}
        <div className="mb-20 lg:mb-28">

          {/* Section eyebrow */}
          <div className="text-center max-w-2xl mx-auto mb-12">
            <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10">
              <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">GMIS News</span>
            </div>
            <h2 className="m-0 font-heading font-bold text-3xl md:text-4xl text-navy uppercase tracking-tight">
              Stories & Features
            </h2>
            <div className="w-12 h-1 bg-gold mx-auto mt-4" />
          </div>

          {/* Featured article – full width */}
          {GMIS_NEWS.filter(n => n.featured).map(item => (
            <a
              key={item.id}
              href="#"
              className="group block bg-white rounded-2xl overflow-hidden border border-line shadow-sm hover:shadow-md transition-shadow duration-300 mb-8"
            >
              <div className="flex flex-col lg:flex-row">
                {/* Image */}
                <div className="lg:w-1/2 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.headline}
                    className="w-full h-[260px] lg:h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                    style={{ minHeight: '280px' }}
                  />
                </div>
                {/* Content */}
                <div className="lg:w-1/2 p-8 lg:p-10 flex flex-col justify-center">
                  <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full border border-gold/30 bg-gold/10 w-fit">
                    <span className="text-gold text-[10px] font-bold tracking-[0.2em] uppercase">{item.category}</span>
                  </div>
                  <h3 className="font-heading font-bold text-2xl md:text-3xl text-navy leading-tight mb-4 group-hover:text-gold transition-colors duration-200">
                    {item.headline}
                  </h3>
                  <p className="text-[16px] text-ink/70 leading-[1.7] mb-6 flex-1">
                    {item.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-ink/40 text-[12px] mb-5 flex-wrap">
                    <span className="flex items-center gap-1.5"><Newspaper size={12}/> {item.author}</span>
                    <span>·</span>
                    <span className="flex items-center gap-1.5"><Calendar size={12}/> {item.date}</span>
                    <span>·</span>
                    <span className="flex items-center gap-1.5"><Clock size={12}/> {item.readTime}</span>
                  </div>
                  <span className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-widest text-gold group-hover:gap-3 transition-all duration-200">
                    Read Article <ArrowUpRight size={14} />
                  </span>
                </div>
              </div>
            </a>
          ))}

          {/* Two smaller article cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {GMIS_NEWS.filter(n => !n.featured).map(item => (
              <a
                key={item.id}
                href="#"
                className="group bg-white rounded-2xl overflow-hidden border border-line shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col"
              >
                <div className="overflow-hidden h-[200px]">
                  <img
                    src={item.image}
                    alt={item.headline}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="inline-flex items-center gap-2 mb-3 px-3 py-1 rounded-full border border-gold/30 bg-gold/10 w-fit">
                    <span className="text-gold text-[10px] font-bold tracking-[0.2em] uppercase">{item.category}</span>
                  </div>
                  <h3 className="font-heading font-bold text-[18px] text-navy leading-snug mb-2 group-hover:text-gold transition-colors duration-200 flex-1">
                    {item.headline}
                  </h3>
                  <p className="text-ink/60 text-[14px] leading-relaxed mb-4 line-clamp-2">{item.excerpt}</p>
                  <div className="flex items-center gap-3 text-ink/35 text-[11px] mb-4 flex-wrap">
                    <span>{item.date}</span>
                    <span>·</span>
                    <span>{item.readTime}</span>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-gold group-hover:gap-3 transition-all duration-200">
                    Read More <ArrowUpRight size={13} />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-line/80 mb-20 lg:mb-28" />

        {/* ══════════════════════════════════════════════════════
            SECTION 2 — GMIS UPDATES
        ══════════════════════════════════════════════════════ */}
        <div className="mb-20 lg:mb-28">

          {/* Section eyebrow */}
          <div className="text-center max-w-2xl mx-auto mb-12">
            <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10">
              <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">GMIS Updates</span>
            </div>
            <h2 className="m-0 font-heading font-bold text-3xl md:text-4xl text-navy uppercase tracking-tight">
              School Announcements
            </h2>
            <div className="w-12 h-1 bg-gold mx-auto mt-4" />
          </div>

          {/* Filter tabs */}
          <div className="flex flex-wrap gap-2 justify-center mb-10">
            {UPDATE_TAGS.map(tag => (
              <button
                key={tag}
                onClick={() => setUpdateFilter(tag)}
                className={`px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-widest transition-all duration-200 ${
                  updateFilter === tag
                    ? 'bg-navy text-white shadow-sm'
                    : 'bg-white text-ink/60 border border-line hover:border-navy hover:text-navy'
                }`}
              >
                {tag}
              </button>
            ))}
          </div>

          {/* Cards grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredUpdates.map(item => (
              <a
                key={item.id}
                href={item.linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-2xl overflow-hidden border border-line shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col"
              >
                {/* Image */}
                <div className="relative overflow-hidden h-[180px] shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-white/95 text-navy text-[9px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full shadow-sm">
                      {item.tag}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 text-ink/40 text-[11px] mb-3">
                    <Calendar size={11} /> {item.date}
                  </div>
                  <h3 className="font-heading font-bold text-[18px] text-navy leading-snug mb-3 group-hover:text-gold transition-colors duration-200">
                    {item.title}
                  </h3>

                  {item.details && (
                    <div className="flex flex-col gap-1.5 mb-3">
                      {item.details.map((d, i) => (
                        <span key={i} className="flex items-center gap-2 text-[12px] text-ink/55">
                          <span className="text-gold">{d.icon}</span>{d.text}
                        </span>
                      ))}
                    </div>
                  )}

                  <p className="text-ink/65 text-[14px] leading-[1.7] flex-1 line-clamp-3 mb-5">
                    {item.desc}
                  </p>

                  <div className="mt-auto pt-4 border-t border-line/60">
                    <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-gold group-hover:gap-3 transition-all duration-200">
                      {item.linkText} <ArrowUpRight size={13} />
                    </span>
                  </div>
                </div>
              </a>
            ))}

            {filteredUpdates.length === 0 && (
              <div className="col-span-3 text-center py-16">
                <Bell size={32} className="mx-auto mb-4 text-navy/20" />
                <p className="font-heading font-semibold text-navy text-base mb-1">No updates for this category.</p>
                <button onClick={() => setUpdateFilter('All')} className="text-[11px] text-gold font-bold hover:underline mt-2">
                  Clear filter
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-line/80 mb-20 lg:mb-28" />

        {/* ══════════════════════════════════════════════════════
            SECTION 3 — VIDEOS
        ══════════════════════════════════════════════════════ */}
        <div className="mb-20 lg:mb-28">

          {/* Section eyebrow */}
          <div className="text-center max-w-2xl mx-auto mb-12">
            <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10">
              <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">Videos</span>
            </div>
            <h2 className="m-0 font-heading font-bold text-3xl md:text-4xl text-navy uppercase tracking-tight">
              Watch & Explore
            </h2>
            <div className="w-12 h-1 bg-gold mx-auto mt-4" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {VIDEOS.map(v => (
              <div
                key={v.id}
                className="group bg-white rounded-2xl overflow-hidden border border-line shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer"
                onClick={() => setVideoModal(v)}
              >
                {/* Thumbnail */}
                <div className="relative overflow-hidden h-[190px]">
                  <img
                    src={v.thumb}
                    alt={v.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  {/* Play overlay */}
                  <div className="absolute inset-0 bg-navy/35 group-hover:bg-navy/20 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full border-2 border-white/80 bg-white/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Play size={20} className="text-white ml-0.5" fill="white" />
                    </div>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading font-bold text-[16px] text-navy leading-snug mb-1 group-hover:text-gold transition-colors duration-200">
                    {v.title}
                  </h3>
                  <p className="text-ink/55 text-[13px] leading-relaxed">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-line/80 mb-20 lg:mb-28" />

        {/* ══════════════════════════════════════════════════════
            SECTION 4 — SOCIAL MEDIA
        ══════════════════════════════════════════════════════ */}
        <div className="mb-20 lg:mb-24">

          {/* Section eyebrow */}
          <div className="text-center max-w-2xl mx-auto mb-12">
            <div className="inline-flex items-center gap-2 mb-3 px-3.5 py-1 rounded-full border border-gold/30 bg-gold/10">
              <span className="text-gold text-[11px] font-bold tracking-[0.2em] uppercase">Follow Us</span>
            </div>
            <h2 className="m-0 font-heading font-bold text-3xl md:text-4xl text-navy uppercase tracking-tight">
              Find Us on Social Media
            </h2>
            <div className="w-12 h-1 bg-gold mx-auto mt-4" />
            <p className="text-ink/55 text-[16px] mt-5 leading-relaxed">
              Stay connected — follow us for daily updates, inspiring stories, and behind-the-scenes moments.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {SOCIAL.map(s => (
              <a
                key={s.id}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-2xl border border-line shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 p-6 flex flex-col items-center text-center"
              >
                <div className="w-12 h-12 rounded-xl bg-navy/5 flex items-center justify-center text-navy mb-4 group-hover:bg-gold/10 group-hover:text-gold transition-all duration-200">
                  {s.icon}
                </div>
                <h4 className="font-heading font-bold text-navy text-[15px] mb-1 group-hover:text-gold transition-colors duration-200">
                  {s.platform}
                </h4>
                <p className="text-ink/40 text-[11px] tracking-wide mb-3">{s.handle}</p>
                <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-gold">
                  Follow <ArrowUpRight size={11} />
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════════════════════
            CTA — matches all School Life / News & Events pages
        ══════════════════════════════════════════════════════ */}
        <div className="w-full bg-navy rounded-3xl p-10 md:p-14 text-center text-white shadow-xl relative overflow-hidden">
          <div className="w-16 h-1 bg-gold mx-auto mb-6" />
          <h3 className="font-heading font-bold text-2xl sm:text-3xl md:text-4xl leading-snug max-w-3xl mx-auto tracking-tight">
            Have a Story to Share with the GMIS Community?
          </h3>
          <p className="text-white/60 mt-4 max-w-xl mx-auto text-[15px] leading-relaxed">
            We'd love to hear about achievements, milestones, or events. Get in touch with our communications team.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <button
              onClick={() => { if (setPage) setPage('contact'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="px-8 py-3.5 rounded-lg bg-gold text-navy font-heading font-bold text-xs uppercase tracking-widest hover:bg-gold/90 transition-all shadow-md"
            >
              Contact Us
            </button>
            <button
              onClick={() => { if (setPage) setPage('newsletter'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="px-8 py-3.5 rounded-lg bg-white/10 text-white font-heading font-bold text-xs uppercase tracking-widest hover:bg-white/20 transition-all border border-white/20"
            >
              View Newsletter
            </button>
          </div>
        </div>

      </div>

      {/* ── Video Modal ─────────────────────────────────────────── */}
      {videoModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-navy/80 backdrop-blur-sm"
            onClick={() => setVideoModal(null)}
          />
          <div className="relative bg-white w-full max-w-3xl rounded-2xl overflow-hidden shadow-2xl">
            {videoModal.youtubeId ? (
              <div className="aspect-video">
                <iframe
                  src={`https://www.youtube.com/embed/${videoModal.youtubeId}?autoplay=1`}
                  title={videoModal.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
            ) : (
              <div className="aspect-video bg-navy/5 flex flex-col items-center justify-center text-center p-10">
                <Play size={48} className="text-navy/15 mb-5" />
                <h3 className="font-heading font-bold text-xl text-navy mb-2 uppercase">
                  {videoModal.title}
                </h3>
                <p className="text-ink/45 text-sm max-w-xs">
                  Video coming soon. Stay tuned for updates from GMIS Jakarta.
                </p>
              </div>
            )}
            <div className="px-6 py-5 border-t border-line">
              <h4 className="font-heading font-bold text-navy text-[15px]">{videoModal.title}</h4>
              <p className="text-ink/55 text-[13px] mt-1">{videoModal.desc}</p>
            </div>
            <button
              onClick={() => setVideoModal(null)}
              className="absolute top-4 right-4 w-9 h-9 bg-navy/80 hover:bg-navy text-white rounded-full flex items-center justify-center transition-colors text-sm font-bold"
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>
      )}

    </div>
  );
}
